import {  FormTextArea} from 'components/shared/Forms/ReduxForm'
import Markdown from 'react-markdown'
import { I18n } from 'lib/i18n'
import React from 'react'
import { Field, formValues } from 'redux-form'
import { Grid, Icon, Label, Segment } from 'semantic-ui-react'

const CategoryTitles = ({description_de, description_fr}) => (
  <Grid stackable>
      <Grid.Row>
        <Grid.Column width={6}>
          <Field
            component={FormTextArea}
            placeholder={I18n.t('admin.product.categories.meta_description_de')}
            name="meta_description_de"
          />
        </Grid.Column>
        <Grid.Column width={6}>
          <Field
            component={FormTextArea}
            placeholder={I18n.t('admin.product.categories.meta_description_fr')}
            name="meta_description_fr"
          />
        </Grid.Column>
      </Grid.Row>

      <Grid.Row>
        <Grid.Column width={6}>
          <Field
            component={FormTextArea}
            placeholder={I18n.t('admin.product.categories.description_de')}
            name="description_de"
          />
          <p>
            {I18n.t('admin.general.supports_markdown')}
            <a
              href="http://commonmark.org/"
              target="_blank"
              rel="noopener noreferrer">
              <Icon name="info circle" color="blue" />
            </a>
          </p>
          {description_de && (
            <Segment raised>
              <Label attached="top right">Vorschau</Label>
              <Markdown source={description_de || ''} skipHtml />
            </Segment>
          )}
        </Grid.Column>
        <Grid.Column width={6}>
          <Field
            component={FormTextArea}
            placeholder={I18n.t('admin.product.categories.description_fr')}
            name="description_fr"
          />
          <p>
            {I18n.t('admin.general.supports_markdown')}
            <a
              href="http://commonmark.org/"
              target="_blank"
              rel="noopener noreferrer">
              <Icon name="info circle" color="blue" />
            </a>
          </p>
          {description_fr && (
            <Segment raised>
              <Label attached="top right">Vorschau</Label>
              <Markdown source={description_fr || ''} skipHtml />
            </Segment>
          )}
        </Grid.Column>
      </Grid.Row>
  </Grid>
)
export default formValues('description_de', 'description_fr')(CategoryTitles)



// WEBPACK FOOTER //
// ./src/components/admin/Categories/CategoryDescriptions.jsx